import type React from 'react';

import { ChevronSortIcon } from '@vlabs/icons';
import type { TOption } from '@vlabs/uikit/types';
import { useTranslation } from 'react-i18next';

import { DropdownSelect } from '@vlabs/monokit/shared/ui/dropdown-select';

import { useSourceFilters } from './useSourceFilters';

// Опции сортировки расширяются добавлением элемента в конфиг и маппингом в filters.
// Пока сервер поддерживает только сортировку по дате создания (order), поле сортировки не передаётся.
export type SourceSortKey = 'create_time_desc' | 'create_time_asc';

export function getSourceSortKey(order: string | undefined): SourceSortKey {
  return order === 'asc' ? 'create_time_asc' : 'create_time_desc';
}

export function getSourceSortOrder(sortKey: SourceSortKey): 'asc' | 'desc' {
  return sortKey === 'create_time_asc' ? 'asc' : 'desc';
}

function SourceGroupSortDropdown(): React.JSX.Element {
  const { t } = useTranslation();
  const { filters, updateFilters } = useSourceFilters();

  const options: TOption<SourceSortKey>[] = [
    { label: t('entities:source_filters.sort.create_time_desc'), value: 'create_time_desc' },
    { label: t('entities:source_filters.sort.create_time_asc'), value: 'create_time_asc' },
  ];

  const value = getSourceSortKey(filters.order);
  const selectedOption = options.find((option) => option.value === value);

  return (
    <DropdownSelect
      icon={<ChevronSortIcon />}
      label={selectedOption?.label ?? ''}
      onSelect={(nextValue) => updateFilters({
        order: getSourceSortOrder(nextValue),
        page: 1,
      })}
      options={options}
      value={value}
    />
  );
}

export { SourceGroupSortDropdown };
